import { userConstants } from "../_constants";

let user = JSON.parse(localStorage.getItem("user"));
const initialState = user
  ? { loggedIn: true, allowCreate: false, email: "", user, loading: false }
  : {};

export function authentication(state = initialState, action) {
  switch (action.type) {
    case userConstants.LOGIN_REQUEST:
    case userConstants.USER_IMPERSONATE_REQUEST:
      return {
        loading: true,
      };
    case userConstants.PASSWORD_RESET_SUCCESS:
    case userConstants.PASSWORD_UPDATE_SUCCESS:
      return {
        user: action.user,
      };
    case userConstants.LOGIN_SUCCESS:
      return {
        loggedIn: true,
        user: action.user,
      };
    case userConstants.USER_IMPERSONATE_SUCCESS:
      return {
        user: action.impersonaUser,
      };
    case userConstants.LOGIN_FAILURE:
    case userConstants.LOGOUT:
      return {};

    case userConstants.PASSWORD_RESET_REQUEST:
    case userConstants.VERIFY_TOKEN_REQUEST:
    case userConstants.VERIFY_DEFAULT_TOKEN_REQUEST:
      return {
        loading: true,
        email: action.email,
      };
   
    case userConstants.PASSWORD_RESET_FAILURE:
    case userConstants.PASSWORD_UPDATE_FAILURE:
    case userConstants.PASSWORD_CHANGE_FAILURE:
    case userConstants.PASSWORD_CREATE_FAILURE:
    case userConstants.USER_IMPERSONATE_FAILURE:
      return {
        error: action.error,
      };
    case userConstants.PASSWORD_UPDATE_REQUEST:
      return {
        loading: true,
      };
   
    case userConstants.PASSWORD_CHANGE_REQUEST:
    case userConstants.PASSWORD_CREATE_REQUEST:
      return {
        email: action.message,
      };
    case userConstants.PASSWORD_CHANGE_SUCCESS:
      return {
        allowReset: true,
        email: action.email,
      };
 
    case userConstants.VERIFY_TOKEN_SUCCESS:
      return {
        allowReset: true,
        email: action.email.email,
        clientId: action.email.clientId,
      };
    case userConstants.VERIFY_TOKEN_FAILURE:
    case userConstants.VERIFY_DEFAULT_TOKEN_FAILURE:
      return {
        allowCreate: false,
        error: action.error,
      };
   
    case userConstants.VERIFY_DEFAULT_TOKEN_SUCCESS:
      return {
        allowCreate: action.email.tokenVerified,
        email: action.email.email,
      };
   
    case userConstants.PASSWORD_CREATE_SUCCESS:
      return {
        email: action.email,
      };
   
    default:
      return state;
  }
}
